import { render } from "./WarningsView.vue?vue&type=template&id=805d1970"
import script from "./WarningsView.vue?vue&type=script&lang=js"
export * from "./WarningsView.vue?vue&type=script&lang=js"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__